<template>
  <div id="app">
    <sectionHeader />
    <sectionBanner />
    <sectionOne />
    <sectionTwo />
    <sectionThree />
    <sectionFour />
    <sectionFive />
    <sectionSix />
    <GameIcon />
    <sectionSeven />
    <sectionFooter />
  </div>
</template>

<script>
import sectionHeader from './components/sectionHeader.vue'
import sectionBanner from './components/sectionBanner.vue'
import sectionOne from './components/sectionOne.vue'
import sectionTwo from './components/sectionTwo.vue'
import sectionThree from './components/sectionThree.vue'
import sectionFour from './components/sectionFour.vue'
import sectionFive from './components/sectionFive.vue'
import sectionSix from './components/sectionSix.vue'
import sectionSeven from './components/sectionSeven.vue'
import GameIcon from './components/GameIcon.vue'
import sectionFooter from './components/sectionFooter.vue'
export default {
  name: 'App',
  components: {
    sectionHeader,
    sectionBanner,
    sectionOne,
    sectionTwo,
    sectionThree,
    sectionFour,
    sectionFive,
    sectionFooter,
    sectionSix,
    sectionSeven,
    GameIcon

  }
}
</script>

<style>
:root {
  --main-bg-color: rgba(238, 235, 228, 1);
  --button-hover: rgba(251, 185, 28, 0.5);
}

html,
body,

div,
span,
applet,
object,
iframe,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a {
  text-decoration: none;
  color: black;
  letter-spacing: .1rem;
}

abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: '';
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

#app {
  font-family: Arial, Helvetica, sans-serif;
  scroll-behavior: smooth;
  max-width: 1300px;
  margin: auto
}

h2 {
  background: linear-gradient(89.34deg, rgba(242, 171, 0, 0.4) 0.37%, rgba(204, 145, 5, 0.353143) 2.92%, rgba(242, 179, 27, 0.236) 21.78%, rgba(228, 168, 26, 0.4) 51.85%, rgba(255, 180, 0, 0.368) 74.79%, rgba(251, 185, 28, 0) 98.24%);
  transform: rotate(-2.46deg);
  background-repeat: no-repeat;
  background-size: 88%;
  background-position: center;
  letter-spacing: 0.1em;
  font-weight: 600;
  font-size: 32px;
  margin: auto;
  width: fit-content;
}


@media screen and (max-width:768px) {

  h2 {

    font-size: 1.5rem;
  }
}


p {
  line-height: 30px;
  letter-spacing: 0.1em;
  font-size: 1.2rem;
  font-weight: 400;
}


button {
  border-radius: 25px;
  padding: .5rem 1rem;
  margin: 1rem auto;
  display: flex;
  justify-content: center;
  font-size: 1.2rem;
  background: #EEEBE4;
  border: 2px solid black;
  letter-spacing: .1rem;
  box-shadow: rgba(0, 0, 0, 0.15) 2.4px 2.4px 3.2px;
  color: black;
}

@media screen and (max-width:768px) {

  p {
    line-height: 25px;
    letter-spacing: 0.05em;
    font-size: 1rem;
  }

  button {
    font-size: 1rem;
  }
}

button:hover {
  background: rgba(251, 185, 28, 0.5);
  transition: all .5s;
  cursor: pointer;
}

body {
  margin: auto;
  background: var(--main-bg-color);
}

.layout {
  margin: 2rem auto;
}

.mb {
  display: none;
}

.pc {
  display: block;
}

@media screen and (max-width:768px) {

  .mb {
    display: block;
  }

  .pc {
    display: none;
  }

  .layout {
    margin: 1.5rem 1rem;
  }
}





.swiper-button-next:after,
.swiper-container-rtl .swiper-button-prev:after {
  display: block;
  content: url('./assets/arrow.png');
  filter: drop-shadow(0px 0px 80px rgba(247, 175, 9, 0.9));
  position: relative;
  right: -1rem;
  top: -1rem;
}


.swiper-button-prev:after,
.swiper-container-rtl .swiper-button-next:after {
  display: block;
  content: url('./assets/arrow.png');
  transform: rotate(180deg);
  filter: drop-shadow(0px 0px 80px rgba(247, 175, 9, 0.9));
  position: relative;
  right: 1rem;
  top: -1rem;
}


.swiper-pagination-bullet-active {
  opacity: 1;
  background: rgba(247, 175, 9, 0.9);
}

option {
  color: black;
}

button {
  color: black;
}

a {
  color: black;
}


h3 {

  font-size: 1.2rem;
}


swiper-slide {
  height: 200px;
}
</style>
